<template>
  <span :style="formattedStyle">
    <label
      :class="getClass"
      @click="onFill"
      :title="title">
      <div v-if="applyCurrencyFormat">{{fillableValue | currency}}</div>
      <div v-else-if="applyDateFormat">{{formattedDateValue}}</div>
      <div v-else>{{fillableValue}}</div>
    </label>
  </span>
</template>

<script>
import moment from 'moment'

export default {
  name: 'PopFillControl',
  props: {
    fillableValue: {
      type: [String, Number, Date],
      default: undefined
    },
    title: {
      type: String,
      default: ''
    },
    displayBlock: {
      type: Boolean,
      default: false
    },
    onFillAction: {
      type: Function,
      default: undefined
    },
    customClass: {
      type: String,
      default: 'popfill-link'
    },
    value: {
      type: [String, Number, Date],
      default: undefined
    },
    doComparison: {
      type: Boolean,
      default: false
    },
    applyCurrencyFormat: {
      type: Boolean,
      default: false
    },
    floatValue: {
      type: String,
      default: ''
    },
    applyDateFormat: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
    }
  },
  computed: {
    isValuesDifferent: function () {
      return this.value !== this.fillableValue
    },
    getColourClass: function () {
      if (!this.doComparison) return 'has-text-success'
      return this.isValuesDifferent ? 'has-text-danger' : 'has-text-success'
    },
    getClass: function () {
      let classToAttach = {}
      classToAttach[this.getColourClass] = true
      classToAttach[this.customClass] = true
      return classToAttach
    },
    formattedStyle: function () {
      let displayBlock = this.displayBlock ? 'block' : 'inline'
      let stylesToAttach = { display: displayBlock }
      
      if (this.floatValue) {
        let floatValue = this.floatValue
        stylesToAttach = {display: displayBlock, float: floatValue}
      }
      return stylesToAttach
    },
    formattedDateValue: function () {
      let tz = moment.tz.guess()
      let formattedPurchaseDate = this.fillableValue ? moment.tz(this.fillableValue, tz).format('YYYY-MM-DD') : null
      if (formattedPurchaseDate) {
        return formattedPurchaseDate
      }
      return ''
    }
  },
  methods: {
    onFill () {
      if (this.onFillAction) this.onFillAction(this.fillableValue)
    }
  },
  mounted: function () {
  }
}
</script>

<style scoped>
  .popfill-link {
    font-size: 0.75rem;
    cursor: pointer;
    margin-top: 3px;
    float: right;
    font-weight: 600;
  }

  .popfill-link-date {
    font-size: 0.75rem;
    cursor: pointer;
    margin-top: 3px;
    font-weight: 600;
  }

</style>
